import styled from 'styled-components';
import OuterLink from '../Link/OuterLink';
export const CustomOuterLink = styled(OuterLink) `
  display: flex;
  align-items: center;
  gap: 1.6rem;

  padding: 0.7rem 1.6rem 0.7rem 0.8rem;

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.highL};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
`;
export const IconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3.4rem;
  height: 3.4rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
`;
//# sourceMappingURL=styles.js.map